<template>
  <div class="home">
    <div class="home_container flex">
      <div class="identity_message">
        <!-- 身份选择-->
        <div class="choice identity_choice">
          <div class="choice_title">
              请选择你当前的身份
          </div>
          <div class="choice_tips">
              你可以在求职设置中修改你的求职偏好
          </div>
          <div class="identity_content">
            <div class="identity_content_top">
              <span>求职意向</span>
              <div class="identity_label flex-c" 
                  :class="{'identity_label_active': form.status == 'student'}"
                  @click="form.status = 'student'"
                  >学生党</div>
              <div class="identity_label flex-c" 
                  :class="{'identity_label_active': form.status == 'already_work'}"
                  @click="form.status = 'already_work'"
                  >职场人</div>
            </div>
            <div class="identity_content_middle">
              <div class="middle_list">
                <p>最高学历</p>
                <div class="flex-bettwen">
                  <el-select class="w200" clearable v-model="form.degree_id" placeholder="请选择最高学历">
                    <el-option v-for="(item, index) in degree" :key="index" :label="item.cn" :value="item.id"></el-option>
                  </el-select>
                  <el-select class="w200" clearable v-model="form.edu_type" placeholder="请选择">
                     <el-option
                      v-for="option in ['全日制', '非全日制', '交换/交流']"
                      :key="option"
                      :label="option"
                      :value="option"/>
                  </el-select>
                </div>
              
              </div>
              <div class="middle_list">
                <p>学校名称</p>
                  <el-autocomplete
                    class="select-input-auto-main"
                    v-model="form.cust_uni_name"
                    :debounce="10"
                    :hide-loading="true"
                    label="university"
                    value-key="name"
                    :fetch-suggestions="remoteMethod"
                    placeholder="请输入"
                    @select="select"
                    :select-when-unmatched="true">

                    <template slot-scope="{ item }">
                      <p v-html="item.highlight"></p>
                    </template>

                  </el-autocomplete>
              </div>
              <div class="middle_list">
                <p>{{form.status == 'already_work' ? '毕业时间' : '预计毕业时间'}}</p> 
                  <el-date-picker
                    style="width: 100%"
                    v-model="graduateYear"
                    type="year"
                    format="yyyy"
                    @change="graduateTime"
                    placeholder="选择毕业时间，精准匹配简历模板">
                  </el-date-picker>
              </div>
            </div>
            <div class="identity_content_bottom">
                <div @click="next">下一步</div>
                <div @click="pre">上一步</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import degree from '@/assets/json/degree';
import api from '@/api';
import { routerTo, get_tUser } from '../../assets/js/util';
export default {
  name:'graduation',
  created(){
    this.form.status = this.$route.query.identify
  },
  data(){
   return {
     form:{
       cust_degree: '', // 学历
       cust_uni_name: '', // 学校
       graduate_at: '', // 毕业时间
       status: '', // 求职状态
       edu_type: '',  // 全日制/非全日制
       university_id: '', // 学校id
       degree_id: '', // 学历id
       graduate_at: '', // 毕业时间
     },
     graduateYear: '', // 毕业时间展示用
     degree, // 学历
     _c_t: ''
   }
  },
  methods:{
    next(){
      this._c_t = get_tUser().c_t
      if (!!this.form.degree_id) {
        this.form.cust_degree = this.degree.find(item => item.id == this.form.degree_id).cn
      }
      api.identity.setIdentity(this.form, this._c_t).then(res => {
        if (res.code === 1000){
          this.$router.push({path: '/jobs/state', query: {identity: this.form.status} })
        }else if (res.code===2001){
          this.$message({
            type:'warning',
            message:resp[0].message
          })
          window.location.href = window.location.origin + '/auth-signin/?type=login';
        }else {
          this.$message({
            type:'warning',
            message:res.message
          })
        }
      })   
    },
    pre(){
      this.$router.go(-1)
    },
    graduateTime (year) {
      year =  new Date(year).getFullYear()
      this.form.graduate_at = year + '-01-01' 
    },  
    async remoteMethod (query, cb) {
      let params = {
        keyword: query
      };
      try {
        let res = await api.cvsEditor.universityAutoCompletions(params);
        if (res.code === 1000) {
          cb && cb((res.data || []));
          this.checkInput(res.data)
        }
      } catch (e) {
        console.log('universityAutoCompletions error:', e)
      }
    },
    select (data) {
      this.form.university_id = data.id
    },
    // 检查输入的是否与自动补全内容完全一样，如果一样，同步id
    checkInput (list) {
      if (!list) return false
      let res = null
      res = list.filter(item => item.name === this.form.cust_uni_name)
      if (res && res.length > 0) {
        this.form.university_id = res[0].id
      } else {
        this.form.university_id = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './jobs_intention.scss';
  .flex-bettwen{
    display: flex;
    justify-content: space-between;
  }
  .identity_content{
    width: 416px;
    margin: 35px auto 0px;
    font-size: 14px;
    font-weight: 400;
    color: #9C9C9C;
    .identity_content_top{
      display: flex;
      align-items: center;  
      margin-bottom: 24px;
      &>:nth-child(2){
        margin-left: 16px;
        margin-right: 12px; 
      }
      .identity_label{
        width: 86px;
        height: 32px;
        border-radius: 16px;
        border: 1px solid #ECECEC;
        cursor: pointer;
      }
    }
    .identity_content_middle{
      .middle_list{
        margin-bottom: 24px;
        &>p{
          margin-bottom: 12px;
          text-align: left;
        }
      }
    }
    .identity_label_active{
      border: 1px solid #FF6644 !important;
      color: #FF6644;
    }
   
  }
  .select-input-auto-main {
    width: 100%;
  }
  .w200 {
    width: 200px;
  }
  /deep/ .es-highlighter {
    color: #FF6644;
  }
</style>
